import { routes } from '@/pages'
import { createContext, useContext, useMemo, type PropsWithChildren } from 'react'

export type MissionsUrlContextValue = {
  missionsUrl: string
  missionDetailsUrl: string
  profileUrl: string
  isWebview: boolean
  platform: 'web' | 'mobile'
}

const MissionsUrlContext = createContext<MissionsUrlContextValue | null>(null)

type MissionsUrlProviderProps = PropsWithChildren<{
  isWebview: boolean
}>

export function MissionsUrlProvider({ children, isWebview = false }: MissionsUrlProviderProps) {
  const value = useMemo((): MissionsUrlContextValue => {
    return {
      missionsUrl: isWebview ? routes.missionsWebview.path : routes.missions.path,
      missionDetailsUrl: isWebview ? routes.missionWebview.path : routes.mission.path,
      profileUrl: isWebview ? routes.profileWebview.path : routes.profile.path,
      isWebview,
      platform: isWebview ? 'mobile' : 'web'
    }
  }, [isWebview])

  return <MissionsUrlContext.Provider value={value}>{children}</MissionsUrlContext.Provider>
}

export function useMissionsUrl(): MissionsUrlContextValue {
  const ctx = useContext(MissionsUrlContext)
  if (!ctx) {
    throw new Error('useMissionsUrl must be used within MissionsUrlProvider')
  }
  return ctx
}

/** Use when the component may render outside missions (falls back to default list path). */
export function useMissionsUrlOptional(): MissionsUrlContextValue | null {
  return useContext(MissionsUrlContext)
}
